import { j as o } from "./jsx-runtime-3tyXYecC.mjs";
import { f as r } from "./index-LyFokDcn.mjs";
import { m as n } from "./tss-DN0acMKN.mjs";
import { k as l } from "./emotion-react.browser.esm-BdEGsKDn.mjs";
import { M as m, d } from "./constants-CnFYFetN.mjs";
const c = l`
	0%,
	80%,
	100% {
		transform: scale(0);
	}

	40% {
		transform: scale(1);
	}
`, f = n({ name: "Loader" })(({ constructs: e, palette: s, mode: a, spacing: t }, { small: i }) => ({
  root: {
    margin: "0 auto",
    textAlign: "center",
    width: 145,
    ...i ? {
      width: 80,
      "& > div": {
        height: 16,
        marginLeft: 10,
        width: 16
      }
    } : {}
  },
  base: {
    animation: `${c} 1.8s infinite ease-in-out`,
    /* GOTCHA: Prevent first frame from flickering when animation starts */
    animationFillMode: "both",
    /* TODO: remove hardcoded background color when CSS variables exist in main app */
    backgroundColor: a === m.Dye ? d.main : r.ifFeature("encore", e.surface.neutral.medium, s.gray[500]),
    borderRadius: r.ifFeature("encore", "15%", "100%"),
    display: "inline-block",
    height: r.ifFeature("encore", 32, 35),
    marginLeft: t(2.5),
    width: r.ifFeature("encore", 32, 35),
    "&:first-of-type": {
      animationDelay: "-0.6s",
      marginLeft: 0
    },
    "&:nth-of-type(2)": {
      animationDelay: "-0.3s"
    }
  }
}));
function u(e) {
  return e ? ` ${e}__progress` : "";
}
const y = ({ blockName: e, small: s }) => {
  const { classes: a, cx: t } = f({ small: s });
  return /* @__PURE__ */ o.jsxs(
    "div",
    {
      "aria-busy": "true",
      "aria-label": window.jQuery ? $.__("loading") : "loading",
      "aria-live": "polite",
      className: t(a.root, u(e)),
      "data-fabric-component": "Loader",
      role: "status",
      children: [
        /* @__PURE__ */ o.jsx("div", { className: a.base }),
        /* @__PURE__ */ o.jsx("div", { className: a.base }),
        /* @__PURE__ */ o.jsx("div", { className: a.base })
      ]
    }
  );
};
y.displayName = "Loader";
export {
  y as L
};
//# sourceMappingURL=loader-CJQkrVUR.mjs.map
